import Vue from 'vue';
import generator from 'generate-password';

export default Vue.component('dynamic-input-text', {
  template: require('./template.html'),
  name: 'dynamic-input-text',
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
    'input-errors',
  ],
  data() {
    return {
      hasErrors: [],
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      this.$set(this.display, this.type, this.activeItem[this.type] || '');
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
    generateRandom() {
      const SKU = generator.generate({
        length: 10,
        numbers: true,
      });
      this.display[this.type] = SKU.toUpperCase();
      this.handleErrors();
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: this.type,
        val: this.getInputVal(this.display[this.type]),
      });
    },
    handleErrors() {
      const value = this.display[this.type] || '';
      const input = value.replace(/\s/g, '');
      this.hasErrors = [];
      this.$emit('set-input-error', 'clear');
      if (this.value.required && input === '') {
        this.hasErrors.push('required');
      }
      if (this.value.regex) {
        const allowed = new RegExp(this.value.regex.value, 'g');
        if (!value.match(allowed)) {
          this.hasErrors.push(this.value.regex.message);
        }
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/text/index.js